import { render, staticRenderFns } from "./Loge.vue?vue&type=template&id=483ac6b6&"
import script from "./Loge.vue?vue&type=script&lang=js&"
export * from "./Loge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports